<template>
   <div class="adminPage DataUpdate">
      <!-- MODAL CREAR / EDITAR -->
      <modal
         name="ProgramModal"
         width="80%"
         height="auto"
         :scrollable="true"
         :adaptive="true"
         :clickToClose="false"
         >
         <div class="modalContainer">
            <div class="titlePage">
               Programa
            </div>
            <div class="tabcontent">
               <ValidationObserver ref="obsFieldsUpdate">
                  <FormUpdatePrograms
                     :FieldsForm="formUpdate"
                     :ModelForm="formUpdModel"
                     :method="executeProcess"
                     v-if="renderComponent2"
                     />
               </ValidationObserver>
               <div class="modalActions">
                  <div style="flex:1"></div>
                  <button
                     v-if="isNew === false"
                     id="UpdateProgram"
                     class="loginbtn primaryBtn"
                     @click="UpdateProgram"
                     >
                  Actualizar
                  </button>
                  <button
                     v-if="isNew === true"
                     id="AddProgram"
                     class="loginbtn primaryBtn"
                     @click="AddProgram"
                     >
                  Guardar
                  </button>
                  <button
                     id="CancelUser"
                     class="loginbtn secondaryBtn"
                     @click="CancelUser"
                     >
                  Cancelar
                  </button>
               </div>
            </div>
         </div>
      </modal>
      <!-- TITULO -->
      <div class="titlePage">
         Administración - Programas Ibero
      </div>
      <!-- NOTIFICACIONES -->
      <va-notification
         color="info"
         v-if="addRExito"
         class="refNoData"
         >
         Se creó correctamente el programa solicitado.
      </va-notification>
      <va-notification
         color="info"
         v-if="UpdRExito"
         class="refNoData"
         >
         Se actualizó correctamente el programa solicitado.
      </va-notification>
      <va-notification
         color="danger"
         v-if="refNoUpdate"
         class="refNoData"
         >
         La actualización del programa presentó un fallo.
      </va-notification>
      <va-notification
         color="danger"
         v-if="refWSUpdate"
         class="refNoData"
         >
         El servicio que ejecuta la actualización no se encuentra activo.
      </va-notification>
      <!-- BUSCADOR -->
      <ValidationObserver ref="obsFieldsSearch">
         <FormSearchProgram
            :FieldsForm="formSearch"
            :ModelForm="formSchModel"
            :method="executeProcess"
            />
      </ValidationObserver>
      <va-notification
         color="danger"
         id="refNoData"
         class="refNoData noShow"
         >
         No se encontró información del programa solicitado.
      </va-notification>
      <!-- TABLA -->
      <div class="tableCard">
         <DataTablePrograms
            :InfoView="DLPrograms"
            :HeadTable="HDProgram"
            :method="processData"
            v-if="renderComponent1"
            />
      </div>
   </div>
</template>
<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormUpdatePrograms from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataPrograms.vue'

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormUpdatePrograms,
  },
  data () {
    return {
      FacultyList: IberoHelpers.getFaculties(this.$store),
      DegreeList: IberoHelpers.getDegrees(this.$store),
      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Faculty',
          model: 'idFaculty',
          name: 'Facultad',
          type: 'Select',
          values: this.$store.state.FacultyList,
          validate: {
            required: false,
          },
          class: 'col-md-5',
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar Programa',
          class: 'col-md-4',
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Crear Programa',
          class: 'col-md-3',
        },
      ],
      formUpdModel: {
        idProgram: 0,
        namProgram: '',
        codProgram: '',
        idFaculty: '',
        homBanner: '',
        homIceberg: '',
        homZoho: '',
        staActive: '',
        homBannerDept: '',
        homBannerCampus: '',
        idDegree: '',
        isMastery: false,
        requirePayment: '',
      },
      formUpdate: [
        {
          id: 'namProgram',
          model: 'namProgram',
          name: 'Nombre Programa',
          type: 'input',
          placeholder: 'Nombre',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 200,
          },
          class: 'col-md-8',
        },
        {
          id: 'codProgram',
          model: 'codProgram',
          name: 'Código Programa',
          type: 'input',
          placeholder: 'Código',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 5,
          },
          class: 'col-md-4',
        },
        {
          id: 'idFaculty',
          model: 'idFaculty',
          name: 'Facultad',
          type: 'Select',
          placeholder: 'Seleccionar...',
          values: this.$store.state.FacultyList,
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'idDegree',
          model: 'idDegree',
          name: 'Nivel de Formación',
          type: 'Select',
          placeholder: 'Seleccionar...',
          validate: {
            required: true,
          },
          class: 'col-md-4',
          values: this.$store.state.DegreeList,
        },
        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-4',
          values: [
            { id: 1, value: 'Activo' },
            { id: 0, value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },
        {
          id: 'homBanner',
          model: 'homBanner',
          name: 'Código Homologación Banner',
          type: 'input',
          placeholder: 'Código Banner',
          values: '',
          validate: {
            max: 5,
          },
          class: 'col-md-4',
        },
        {
          id: 'homIceberg',
          model: 'homIceberg',
          name: 'Código Homologación Iceberg',
          type: 'input',
          placeholder: 'Código Iceberg',
          values: '',
          validate: {
            max: 5,
          },
          class: 'col-md-4',
        },
        {
          id: 'homZoho',
          model: 'homZoho',
          name: 'Código Homologación Zoho',
          type: 'input',
          placeholder: 'Código Zoho',
          values: '',
          validate: {
            numeric: true,
            max: 20,
          },
          class: 'col-md-4',
        },
        {
          id: 'homBannerDept',
          model: 'homBannerDept',
          name: 'Código Homologación Dept Banner',
          type: 'input',
          placeholder: 'Dept Banner',
          values: '',
          validate: {
            max: 5,
          },
          class: 'col-md-4',
        },
        {
          id: 'homBannerCampus',
          model: 'homBannerCampus',
          name: 'Código Homologación Campus Banner',
          type: 'input',
          placeholder: 'Código Campus',
          values: '',
          validate: {
            required: false,
            max: 5,
          },
          class: 'col-md-4',
        },
        {
          id: 'isMastery',
          name: 'Es Maestria',
          model: 'isMastery',
          type: 'accepted',
          placeholder: 'Maestria',
          values: false,
          validate: {
            required: false,
          },
          class: 'col-md-2 linkref',
        },
        /* {
          id: 'isPay',
          name: 'Requiere Pago',
          model: 'isPay',
          type: 'accepted',
          placeholder: 'Inscripción',
          values: false,
          validate: {
            required: false,
          },
          class: 'col-md-2 linkref',
        }, */
        {
          id: 'requirePayment',
          model: 'requirePayment',
          name: 'Descripción Mensaje',
          type: 'input',
          placeholder: 'Digite el texto que quiere que se muestre en pantalla para informar al usuario que este programa requiere de un pago.',
          values: this.$store.state.requirePayment,
          class: 'col-md-12 noShow',
          validate: {
            required: false,
            regex: '^([a-zA-z]?)',
            max: 250,
          },
        },
      ],
      HDProgram: [
        {
          name: 'codProgram',
          title: 'Código',
          width: '20%',
        },
        {
          name: 'namProgram',
          title: 'Nombre Programa',
          sortField: 'namProgram',
          width: '60%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLPrograms: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then(results => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Sch_ButtonNew':
          this.limpiaref()
          this.clearFields()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('ProgramModal')
      }
      this.$refs.obsFieldsSearch.validate()
    },
    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      this.isNew = false
      let loader = this.$loading.show()
      var ListPrograms = IberoHelpers.getPrograms(this.$store, this.formSchModel, 0)
      this.renderComponent1 = false
      ListPrograms.then(Response => {
        if ((Response.data === undefined) || (Response.data === '')) {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPrograms = Response.data
          } else {
            this.DLPrograms = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },
    UpdateProgram () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var totalinf = IberoHelpers.updateProgram(this.$store, this.formUpdModel)
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.UpdRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    AddProgram () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then(results => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()
            var totalinf = IberoHelpers.addProgram(this.$store, this.formUpdModel)
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.addRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')
              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },
    CancelUser () {
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('ProgramModal')
    },
    limpiaref () {
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      this.formUpdModel.idProgram = 0
      this.formUpdModel.namProgram = ''
      this.formUpdModel.codProgram = ''
      this.formUpdModel.idFaculty = ''
      this.formUpdModel.idDegree = ''
      this.formUpdModel.staActive = ''
      this.formUpdModel.homBanner = ''
      this.formUpdModel.homIceberg = ''
      this.formUpdModel.homZoho = ''
      this.formUpdModel.homBannerDept = ''
      this.formUpdModel.homBannerCampus = ''
      this.formUpdModel.isMastery = false
      this.formUpdModel.requirePayment = ''
    },
    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      this.formUpdModel.idProgram = dataInf.idProgram
      this.formUpdModel.codProgram = dataInf.codProgram
      this.formUpdModel.namProgram = dataInf.namProgram
      this.formUpdModel.idFaculty = dataInf.idFaculty
      this.formUpdModel.idDegree = dataInf.idDegree
      if (dataInf.staActive === true) { this.formUpdModel.staActive = 1 } else { this.formUpdModel.staActive = 0 }
      this.formUpdModel.homBanner = dataInf.homBanner
      this.formUpdModel.homIceberg = dataInf.homIceberg
      this.formUpdModel.homZoho = dataInf.homZoho
      this.formUpdModel.homBannerDept = dataInf.homBannerDept
      this.formUpdModel.homBannerCampus = dataInf.homBannerCampus
      this.formUpdModel.isMastery = dataInf.isMastery
      this.formUpdModel.requirePayment = dataInf.requirePayment
      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>